var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var BaseSubscriptionService = function () {
  function BaseSubscriptionService() {
    _classCallCheck(this, BaseSubscriptionService);
    this.subscription = null;
  }

  /**
   * 1) Tell server to subscribe to level1 data for passed `instrumentId`
   * 2) Get first portion of data
   */

  _createClass(BaseSubscriptionService, [{
    key: 'initSubscribtion',
    value: function initSubscribtion(instrumentId) {
      throw Error('not implemented');
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      throw Error('not implemented');
    }

    /**
     * Stop getting updates from server
     */
  }, {
    key: 'stop',
    value: function stop() {
      throw Error('not implemented');
    }

    /**
     * Stop getting updates from server for one instrument
     *
     */
  }, {
    key: 'stopOne',
    value: function stopOne(insrtumentId) {
      throw Error('not implemented');
    }

    /**
     * Remove listener
     */
  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
      this.subscription = null;
    }

    /**
     * 1) Tell server to stop getting updates
     * 2) Remove listener
     */
  }, {
    key: 'stopAll',
    value: function stopAll() {
      this.unsubscribe();
      this.stop();
    }
  }]);
  return BaseSubscriptionService;
}();
export default BaseSubscriptionService;